module.exports = __webpack_public_path__ + "static/media/19.14ea8c08.jpeg";